// extracted by mini-css-extract-plugin
module.exports = {"coloredBlock":"coloredBlock__EYQXf"};